import rootReducer from "../../../store";
import { setAffinityGroupData } from "../../../slices/ag/affinityGroup/affinityGroupSlice";
import {
  resetFormState,
  setTableLoading,
} from "../../../slices/common/reducer";
import { setDrodownData } from "../../../slices/header/headerSlice";
import { getSwitchDropdown } from "../../../Utils/CommonService";
import { showToast } from "../../../common/Toaster/Toaster";
import api from "../../../Utils/interface";

export const getAffinityList = (entity_type) => {
  const setLoadingTimeout = setTimeout(() => {
    rootReducer.dispatch(setTableLoading(true));
  }, 300);
  api
    .post(`/entity/readAll`, null, {
      params: {
        entity_type: entity_type,
      },
    })
    .then((res) => {
      rootReducer.dispatch(setAffinityGroupData(res.data));
      clearTimeout(setLoadingTimeout);
    })
    .catch((err) => {
      console.log(err);
      clearTimeout(setLoadingTimeout);
      rootReducer.dispatch(setTableLoading(false));
    });
};

export const createAffinityList = (entity_type, formData, navigator) => {
  let fd = new FormData();

  fd.append("entity", JSON.stringify(formData));
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/create`, fd, {
    })
    .then((res) => {
      rootReducer.dispatch(resetFormState());
      const updatedDropdownData = getSwitchDropdown();
      rootReducer.dispatch(setDrodownData(updatedDropdownData));
      showToast("AG created successfully", "success");
      navigator("/ag/ag");
    })
    .catch((err) => {
      showToast(err?.response?.data?.error_message, "error");
    });
};

export let updateAffinityList = async (entity, entityid, navigator) => {
  const updatedEntity = {
    ...entity,
    entityid: entityid,
    entitytype: "AGRP",
  };


  let fd = new FormData();
  fd.append("entityid", entityid);
  fd.append("entitytype", updatedEntity.entitytype);
  fd.append("entity", JSON.stringify(updatedEntity));

  api
    .post(`/entity/update`, fd, {
    })
    .then((res) => {
      rootReducer.dispatch(resetFormState());
      const updatedDropdownData = getSwitchDropdown();
      rootReducer.dispatch(setDrodownData(updatedDropdownData));
      navigator("/ag/ag");
      showToast("AG updated successfully", "success");
    })
    .catch((err) => {
      showToast(err?.response?.data?.error_message, "error");
    });
};
